import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const investors = [{
  name: 'Peyush Bansal',
  role: 'Lenskart',
  initials: 'PB'
}, {
  name: 'Ashneer Grover',
  role: 'BharatPe',
  initials: 'AG'
}, {
  name: 'Anupam Mittal',
  role: 'Shaadi.com',
  initials: 'AM'
}, {
  name: 'Aman Gupta',
  role: 'boAt',
  initials: 'AG'
}, {
  name: 'Equanimity Ventures',
  role: 'VC Fund',
  initials: 'EV'
}, {
  name: 'Rajiv Dadlani Group',
  role: 'Strategic',
  initials: 'RD'
}, {
  name: 'Arihant Patni',
  role: 'Angel',
  initials: 'AP'
}, {
  name: 'Miten Sampat',
  role: 'Angel',
  initials: 'MS'
}, {
  name: 'Ekta Kapoor',
  role: 'Angel',
  initials: 'EK'
}, {
  name: 'Ritesh Malik',
  role: 'Angel',
  initials: 'RM'
}, {
  name: 'Aakrit Vaish',
  role: 'Haptik',
  initials: 'AV'
}, {
  name: 'Sumeet Srivastava',
  role: 'Angel',
  initials: 'SS'
}, {
  name: 'Amit Lath',
  role: 'Angel',
  initials: 'AL'
}, {
  name: 'Avik Ashar',
  role: 'Angel',
  initials: 'AA'
}];
export function Investors() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <section id="investors" ref={ref} className="py-24 bg-white thread-pattern" data-id="element-393">
      <div className="max-w-6xl mx-auto px-5 lg:px-8" data-id="element-394">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-14" data-id="element-395">
          <p className="text-xs font-inter font-semibold text-[#E8500A] tracking-[0.18em] uppercase mb-4" data-id="element-396">
            Backed By The Best
          </p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4" data-id="element-397">
            <h2 className="font-jakarta text-4xl md:text-5xl font-extrabold text-[#0F0E0C] leading-tight" data-id="element-398">
              Even Sharks
              <br data-id="element-399" />
              <span className="gradient-text" data-id="element-400">agreed.</span>
            </h2>
            <p className="text-[#5C5A55] font-inter max-w-xs text-base leading-relaxed" data-id="element-401">
              Featured on Shark Tank India Season 1 with 1M+ views. Backed by
              India's most prominent founders and investors.
            </p>
          </div>
        </motion.div>

        {/* Shark Tank highlight card */}
        <motion.a href="https://www.youtube.com/watch?v=yi8xTTuB4V0" target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 12
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="mb-12 p-6 rounded-2xl bg-[#FAFAF8] border border-[#E8E4DC] flex flex-col sm:flex-row items-start sm:items-center gap-5 hover:border-[#D4CFC5] hover:shadow-md hover:shadow-black/5 transition-all duration-300 card-lift block" data-id="element-402">
          <div className="w-12 h-12 rounded-2xl bg-red-600 flex items-center justify-center flex-shrink-0 shadow-md shadow-red-600/20" data-id="element-403">
            <svg className="w-5 h-5 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24" data-id="element-404">
              <path d="M8 5v14l11-7z" data-id="element-405" />
            </svg>
          </div>
          <div className="flex-1" data-id="element-406">
            <div className="font-jakarta font-extrabold text-[#0F0E0C] text-lg mb-1" data-id="element-407">
              Shark Tank India · Season 1
            </div>
            <div className="text-sm text-[#9B9890] font-inter" data-id="element-408">
              1 Million+ views · Funded by Shark Tank investors
            </div>
          </div>
          <span className="flex-shrink-0 inline-flex items-center gap-2 px-4 py-2 bg-[#0F0E0C] hover:bg-[#1C1917] text-white text-sm font-inter font-semibold rounded-xl transition-colors magnetic-btn" data-id="element-409">
            Watch Pitch
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-410">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" data-id="element-411" />
            </svg>
          </span>
        </motion.a>

        {/* Investors grid */}
        <div className="flex flex-wrap gap-2.5" data-id="element-412">
          {investors.map((inv, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.88,
          filter: 'blur(3px)'
        }} animate={isInView ? {
          opacity: 1,
          scale: 1,
          filter: 'blur(0px)'
        } : {}} transition={{
          duration: 0.5,
          delay: i * 0.07,
          ease: [0.34, 1.56, 0.64, 1]
        }} whileHover={{
          y: -2,
          transition: {
            duration: 0.15
          }
        }} className="flex items-center gap-2.5 px-4 py-2.5 rounded-full border border-[#E8E4DC] bg-[#FAFAF8] hover:border-[#E8500A]/30 hover:bg-[#FFF7F3] transition-all duration-200 cursor-default card-lift" data-id="element-413">
              <div className="w-7 h-7 rounded-full bg-[#E8500A]/10 border border-[#E8500A]/20 flex items-center justify-center flex-shrink-0" data-id="element-414">
                <span className="text-[9px] font-jakarta font-extrabold text-[#E8500A]" data-id="element-415">
                  {inv.initials}
                </span>
              </div>
              <div data-id="element-416">
                <div className="text-xs font-inter font-semibold text-[#0F0E0C] leading-none" data-id="element-417">
                  {inv.name}
                </div>
                <div className="text-[10px] text-[#9B9890] font-inter leading-none mt-0.5" data-id="element-418">
                  {inv.role}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}